import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import countdownSound from "../../Assets/sounds/countdownSound.mp3";

function Countdown({
  onCountdownEnd,
  onCountNumberChange,
  showFullCountdown = true,
}) {
  // 3 → 2 → 1 → Go
  // OR
  // Go (1 second)
  const [count, setCount] = useState(showFullCountdown ? 3 : 0);

  const audioRef = useRef(null);

  // Play sound only for full countdown
  useEffect(() => {
    if (!showFullCountdown) return;

    audioRef.current = new Audio(countdownSound);

    audioRef.current.play().catch((error) => {
      console.error("Audio playback failed:", error);
    });

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [showFullCountdown]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (showFullCountdown) {
        if (count > 0) {
          const newCount = count - 1;
          setCount(newCount);

          if (onCountNumberChange) {
            onCountNumberChange(newCount);
          }
        } else {
          clearInterval(interval);
          onCountdownEnd?.();
        }
      } else {
        // Show only "Go" for 1 second
        clearInterval(interval);
        onCountdownEnd?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [
    count,
    showFullCountdown,
    onCountdownEnd,
    onCountNumberChange,
  ]);

  const countdownStyle = {
    background: "rgba(0, 0, 0, 0.7)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999999,
  };

  const numberStyle = {
    fontSize: "150px",
    fontFamily: "'Noto Serif', serif",
    fontWeight: "bold",
    color: "white",
    textShadow: "0 0 30px rgba(0,0,0,0.5)",
  };

  return createPortal(
    <div style={countdownStyle} className="countdown-portal-overlay">
      <div style={numberStyle}>
        {showFullCountdown
          ? count === 0
            ? "Go"
            : count
          : "Go"}
      </div>
    </div>,
    document.body
  );
}

export default Countdown;